<template>
  <SpmFunc
    :url="dateObject.courseDetailUrl"
    :spm="spmVideo"
    :index="index"
    :view="spmView"
    :report="spmClick"
  >
    <div class="video-content-item">
      <div class="video-content-img">
        <img :src="dateObject.courseImgUrl" class="module-click" />
        <button v-if="tabs === 1" class="fee-button">付费课程</button>
        <button v-if="tabs === 2" class="vip-button">VIP课程</button>
      </div>
      <div class="video-detailed">
        <p class="rowspan module-click video-title">{{ dateObject.courseTitle }}</p>
        <span>购买时间{{ dateObject.createdTime }}</span>
        <div class="bottomx">
          <el-progress
            class="progress"
            :percentage="dateObject.learningPercentage == undefined ? 0 : Number(dateObject.learningPercentage)"
            color="#409EFF"
          ></el-progress>
          <div>
            <a :href="dateObject.jumpUrl" target="_blank">继续学习</a>
            <button>课程详情</button>
          </div>
        </div>
      </div>
    </div>
  </SpmFunc>
</template>

<script>
import SpmFunc from "@/components/Base/SpmFunc.vue";

export default {
  components: {
    SpmFunc,
  },
  props: {
    dateObject: {
      type: Object,
    },
    tabs: {
      type: Number,
    },
    index: {
      type: Number,
    },
  },
  computed: {
    spmView() {
      let temp = {
        spm: "1003.2449.3001.7930",
        dest: this.dateObject.courseDetailUrl,
        index: this.index,
      };
      return temp;
    },
    spmClick() {
      let temp = {
        spm: this.spmVideo,
        dest: this.dateObject.courseDetailUrl,
        index: this.index,
      };
      return temp;
    },
    // 区分不同的点击埋点
    spmVideo() {
      switch (this.tabs) {
        case 0:
          return "1003.2449.3001.8294";
        case 1:
          return "1003.2449.3001.8293";
        case 2:
          return "1003.2449.3001.8295";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.video-content-item {
  display: flex;
  margin-bottom: 16px;
  cursor: pointer;

  .video-content-img {
    position: relative;
    width: 156px;
    height: 88px;
    background: #f5f6f7;
    border-radius: 2px;
    margin-right: 12px;

    img {
      width: 156px;
      height: 88px;
      background: #f5f6f7;
      border-radius: 2px;
      object-fit: cover;
    }

    button {
      position: absolute;
      top: 6px;
      left: 6px;
      width: 66px;
      height: 24px;
      border-radius: 2px;
    }
    .fee-button {
      background: #222226;
      font-size: 14px;
      font-weight: 400;
      color: #fae8d0;
      line-height: 20px;
    }
    .vip-button {
      background: linear-gradient(270deg, #f8c883 0%, #fae8d0 100%);

      font-size: 14px;
      font-weight: 400;
      color: #69421b;
      line-height: 20px;
    }
  }

  .video-detailed {
    position: relative;

    .video-title {
      font-weight: 500;
    }

    p {
      width: 598px;
      font-size: 14px;
      font-weight: 400;
      color: #555666;
      line-height: 20px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-bottom: 12px;
    }

    span {
      margin-bottom: 20px;
      display: block;
      font-size: 12px;
      font-weight: 400;
      color: #555666;
      line-height: 16px;
    }

    .bottomx {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .progress {
        width: 150px;
      }

      a {
        padding: 6px;
        font-size: 12px;
        text-decoration: underline;
        color: #222226;
      }

      button {
        width: 64px;
        height: 24px;
        background: #ffffff;
        border: 0;
        font-size: 12px;
        font-weight: 400;
        color: #222226;
        line-height: 16px;
      }
    }
  }

  @media screen and (max-width: 1440px) {
    .video-detailed {
      width: calc(~"100% - 168px") !important;
    }
  }
}
</style>